import React, { Component } from 'react';

interface IProps {
  statusHandler: any;
  bannedItem: any;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
  step: number;
}

interface IState {

  prohibitedItemsFound: boolean;
  value: string;
  correctAnswers: boolean;
}

export class ProhibitedItemsComponent extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);


    this.state = {
      prohibitedItemsFound: true,
      value: null,
      correctAnswers: true
    };
  }

  handleChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    const { name, checked } = event.target;
    const answer = name === 'option-yes' && checked ? 'Yes' : 'No';

    this.setState((prevState) => ({
      ...prevState,
      value: answer,
      prohibitedItemsFound: answer === 'Yes',
      correctAnswers: answer === 'No',
    }));
  }

  render() {
    const { language, multiLang, step } = this.props;
    const { prohibitedItemsFound, value, correctAnswers } = this.state;

    return (
      <>
        <div className='preStep'>
          <div className='preStep__title'>
            <h2>{multiLang[`ProhibitedItemsTitle${language}`]}</h2>
          </div>
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>
                {multiLang[`ProhibitedItemsPanelTitle${language}`]}
              </h2>
            </div>
            <div className='preStep__body preStep__body__prohibited-item-list'>
              <div className='contentBox'>
                <div className='prohibited_items_list'>
                  <img
                    src={this.props.bannedItem}
                    alt={'prohibited items'}
                  />
                </div>
              </div>
              <div className='grayBox'>
                <p>
                  {multiLang[`ProhibitedItemsMessage${language}`]}
                </p>
              </div>

              <div className='preStep__declaration'>
                <ul>
                  <li >
                    <div className='item-action'>
                      <div
                        className='form__control'
                      >
                        <input
                          type='radio'
                          name={`option-yes`}
                          id={`option-yes`}
                          checked={value === 'Yes'}
                          onChange={(event) =>
                            this.handleChange(
                              event
                            )
                          }
                        />
                        <label
                          htmlFor={`option-yes`}
                        >
                          {multiLang[`Yes${language}`]}
                        </label>
                      </div>

                      <div
                        className='form__control'
                      >
                        <input
                          type='radio'
                          name={`option-No`}
                          id={`option-No`}
                          checked={value === 'No'}
                          onChange={(event) =>
                            this.handleChange(
                              event
                            )
                          }
                        />
                        <label
                          htmlFor={`option-No`}
                        >
                          {multiLang[`No${language}`]}
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              {!correctAnswers && (
                <div className='grayBox bg-orange'>
                  <p>{multiLang[`securityDeclarationMessage${language}`]}</p>
                </div>
              )}


              <div className='preStep__footer'>
                <button
                  className='btn btn__purple'
                  disabled={prohibitedItemsFound}
                  onClick={() => this.props.statusHandler(step + 1)}
                >
                  {multiLang[`ProhibitedItemsButton${language}`]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ProhibitedItemsComponent;



// WEBPACK FOOTER //
// ./src/components/prohibited-items/prohibited-items.component.tsx